@charset "UTF-8";

/* src/app/forms/json-component/request-config/request-config/request-config.component.scss */
:host {
  display: block;
  padding: 16px;
  background-color: #fdfbff;
  font-family: Arial, sans-serif;
  width: 100%;
  max-width: 1024px;
  margin: auto;
}
h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: #333;
}
.input-group {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.input-group label {
  width: 160px;
  font-weight: 500;
  font-size: 14px;
  color: #444;
  margin-right: 8px;
}
.input-group input,
.input-group select {
  flex: 1;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  max-width: 500px;
}
.input-group textarea {
  flex: 1;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  min-height: 80px;
  resize: vertical;
  max-width: 500px;
}
.input-group button {
  margin-left: 8px;
  height: 36px;
  width: 36px;
  min-width: 36px;
}
button[mat-raised-button] {
  margin-top: 16px;
  background-color: #d700ff;
  color: white;
  font-weight: bold;
  padding: 8px 24px;
  border-radius: 6px;
}
.json-preview pre {
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 20px;
}
/*# sourceMappingURL=request-config.component.css.map */
